import { apiRequest } from "../util/apiUtils";

export const postList = async (params) => {
  try {
    const res = await apiRequest("get", `post/backend/job/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postFeedList = async (params) => {
  try {
    const res = await apiRequest("get", `post/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

// for user Job list
export const jobUserList = async (params) => {
  try {
    const res = await apiRequest("get", `post/job/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postAddEdit = async (payload) => {
  try {
    // Extract ID from FormData
    const id = payload.get ? payload.get("id") : payload?.id;

    const res = await apiRequest(
      id ? "put" : "post",
      `/post/backend/job/${id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data",
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postFrontAddEdit = async (payload) => {
  try {
    // Extract ID from FormData
    const id = payload.get ? payload.get("id") : payload?.id;

    const res = await apiRequest(
      id ? "put" : "post",
      `/post/${id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data",
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const RecruiterpostAddEdit = async (payload) => {
  try {
    // Extract ID from FormData
    const id = payload.get ? payload.get("id") : payload?.id;

    const res = await apiRequest(
      id ? "put" : "post",
      `/post/job/${id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data",
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `post/backend/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postJobDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `post/backend/job/del`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `post/backend/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `post/backend/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postDetails = async (payload) => {
  try {
    const res = await apiRequest(
      "get",
      `post/backend/job/detail/${payload?.slug ? payload?.slug + "-" + payload?.uid : payload?.id}`,
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const jobDetailsUser = async (payload) => {
  try {
    const res = await apiRequest("get", `/post/job/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const saveJob = async (payload) => {
  try {
    const res = await apiRequest("post", `/reaction/toggle`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const CommentAdd = async (payload) => {
  try {
    const res = await apiRequest("post", `/comment/add`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const commentList = async (params) => {
  try {
    const res = await apiRequest("get", `comment/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const dashboardList = async (params) => {
  try {
    const res = await apiRequest("get", `dashboard/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const pageList = async (params) => {
  try {
    const res = await apiRequest("get", `/post/page/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const pageDetails = async (payload) => {
  try {
    const res = await apiRequest(
      "get",
      `post/page/detail/${payload?.slug ? payload?.slug : payload?.id}`,
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const pageAddEdit = async (payload) => {
  try {
    // Extract ID from FormData
    const id = payload.get ? payload.get("id") : payload?.id;

    const res = await apiRequest(
      id ? "put" : "post",
      `/post/page/${id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data",
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
